<template>
  <div class="thankyou-container">
    <div class="w100 padded">
      <img
        class="card"
        src="@/assets/img/ofertaNomina/cajaDeAhorro/accounts-transfer-ok.png"
        alt="Transacción Exitosa"
      />
      <wrap-container class="thankyou-inner-container">
        <caja-ahorro-next-steps />
        <wrap-container class="cascade w50">
          <div class="offer-container">
            <p class="titulo-detalle">¿Qué incluye tu oferta?</p>
            <offer-group item-color="white" item-icon="azul" no-margin>
              <offer-element
                label-light="true"
                v-for="item in oferta"
                v-bind:key="item"
                :label="item"
              />
            </offer-group>
            <p>
              Te enviamos el detalle de tu solicitud <br />
              a
              <strong
                ><span data-obfuscate>{{ email }}</span
                >.</strong
              >
            </p>
            <p>
              <strong>
                Para ayudarte con el proceso de alta de Plan Sueldo:
              </strong>
            </p>
            <ul>
              <li>
                Te van a contactar telefónicamente desde BBVA.
              </li>
              <li>
                Vas a recibir un mail desde la casilla:
                <strong>cuentasueldosop-arg@bbva.com</strong> (por favor, revisá
                tu correo no deseado).
              </li>
              <li>
                También podés contactarnos al 0810-222-0000 (Opción 3) - los
                días hábiles de 9 a 15 hs.
              </li>
            </ul>
          </div>
        </wrap-container>
      </wrap-container>
      <modal-clave-usuario
        v-if="showModalClaveUsuario"
        v-on:close="showModalClaveUsuario = false"
      />
    </div>
  </div>
</template>
<script>
import WrapContainer from "@/components/core/Container";
import OfferElement from "@/components/core/OfferElement";
import OfferGroup from "@/components/core/OfferGroup";
import { DO_SOLICITAR_TURNO } from "../config/constants/action-types";
import { ON_GRACIAS_GTM } from "../config/constants/mutation-types";
import ModalClaveUsuario from "@/components/core/modals/ModalClaveUsuario";
import CajaAhorroNextSteps from "@/components/core/custom/CajaAhorroNextSteps";

const campania = _BBVA_MOTOR || "ofertaNomina";

export default {
  name: "GraciasCA",
  components: {
    WrapContainer,
    OfferElement,
    OfferGroup,
    ModalClaveUsuario,
    CajaAhorroNextSteps
  },
  data() {
    return {
      oferta: require(`@/config/brands/${campania}.js`).oferta,
      showModalClaveUsuario: false
    };
  },
  mounted() {
    this.$store.commit(ON_GRACIAS_GTM, "caja");
  },
  methods: {
    showModal() {
      this.showModalClaveUsuario = true;
    },
    solicitarTurno() {
      this.$store.dispatch(DO_SOLICITAR_TURNO);
    }
  },
  computed: {
    email() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.email) {
        return consulta.email;
      }
      return "";
    }
  }
};
</script>

<style scoped>
div.thankyou-container {
  color: white;
  text-align: left;
}

p.titulo-detalle {
  font-size: 20px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

.card {
  width: 151px;
  height: 113px;
}

@media screen and (min-width: 600px) {
  .thankyou-inner-container {
    display: flex;
  }
  .w50:first-child {
    padding-right: 20px;
  }
  .w50:last-child {
    padding-left: 20px;
    padding-top: 122px; /* Alineación de título "próximos pasos" */
    padding-right: 50px; /* Evitar ser tapado por flotante ayuda */
  }
  .titulo-detalle {
    margin-top: 0;
  }
}

@media screen and (min-width: 1025px) {
  .offer-container {
    margin-top: -90px;
  }
}
</style>
